import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {TooltipHeadPosition} from 'src/app/components/common/tooltip/models/tooltip-head-position';
import {TooltipInfo} from 'src/app/components/common/tooltip/models/tooltip-info';

@Injectable({
  providedIn: 'root'
})
export class TooltipService {


  onVisibilityChange: Subject<TooltipInfo> = new Subject<TooltipInfo>();

  constructor() { }

  show($event, tooltipPosition : TooltipHeadPosition, color:string, component: any, data: any){

    const tipInfo         = new TooltipInfo();
    tipInfo.isVisible   = true;
    tipInfo.position    = tooltipPosition;
    tipInfo.sourceEvent = $event;
    tipInfo.component   = component;
    tipInfo.data        = data;
    tipInfo.color       = color;
    this.onVisibilityChange.next( tipInfo );

  }

  hide(){
    this.onVisibilityChange.next(null);
  }
}
